import Environment from '../../Environment';

export default {
  appName: 'omni',
  url: Environment.unleashService,
  clientKey: Environment.unleashClientKey,
};
